import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "PlatformYunji"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.87598 2H21.1315V4.13592H2.87598V2ZM23 11.2646H11.6462L6.37985 19.0206C6.98058 19.2142 7.68811 19.4078 8.50243 19.5479C11.7731 20.122 15.2106 19.7348 18.7348 18.3865L16.3786 14.1214L18.4745 12.9533L22.6863 20.5892L20.5904 21.7573L19.8428 20.4023C16.659 21.6572 13.8222 22.091 11.4193 22.091C6.18629 22.091 3.01578 20.0285 2.82221 19.9017L4.10376 18.0328L8.67597 11.2712H1V9.13531H23V11.2646Z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/PlatformYunji.vue"]]);
